import {
  deviceMetadataOf,
  parseGpx,
  type RawTelemetryData,
  UNKNOWN_DEVICE,
} from '@pitbrain/shared'
import useApi from '../../../api/useApi'
import ConfigurationContext from '../../../core/providers/ConfigurationContext'
import { useContext } from 'react'
import { GPS_ONLY_FEATURES, useCreateSession } from '../useCreateSession'
import { type UploadFormat } from '../UploadFormat'
import { readFileAsText } from './readFileAsText'

export const useGpxProcessor = (): UploadFormat => {
  const bffConfig = useContext(ConfigurationContext)
  const api = useApi(bffConfig)
  const createSession = useCreateSession(api)

  const processFile = async (file: File, sessionId: string) => {
    const gps = parseGpx(await readFileAsText(file))
    if (gps.length === 0) {
      throw new Error(
        'No track points with a position and time were found in the GPX file.'
      )
    }

    const rawTelemetry: RawTelemetryData = {
      gps,
      recordingStartTime: gps[0].timestamp,
      device: deviceMetadataOf(UNKNOWN_DEVICE),
    }
    await createSession(rawTelemetry, {
      sessionId,
      fileName: file.name,
      device: UNKNOWN_DEVICE,
      sessionFeatures: GPS_ONLY_FEATURES,
    })
  }

  return {
    extensions: ['.GPX'],
    keepsFileAsSource: true,
    processFile,
    error: api.error,
  }
}
